import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/react-hooks";
import * as Sentry from "@sentry/react";

import "assets/sass-photos/main.sass";

import store from "js/stores/reduxStore";
import { apolloClient } from "js/apollo/apollo-client";
import App from "./App";
import { preCacheCurrentUser } from "js/helpers/currentUserCache";
import "js/helpers/sentry_client.js";

if (module.hot) {
    module.hot.accept(err => console.warn(err));
}

export const ClientApp = () => (
    <Sentry.ErrorBoundary fallback={"An error has occured in Photos Module"}>
        <Provider store={store}>
            <ApolloProvider client={apolloClient}>
                <App />
            </ApolloProvider>
        </Provider>
    </Sentry.ErrorBoundary>
);

// Read the currentUser from the DOM and pre-cache it in Apollo client.
preCacheCurrentUser(apolloClient);

// Copypasta. Replace me with whatever makes sense to render the app.
const exists = document.getElementById("root");
if (!exists) {
    const root = document.createElement("div");
    root.id = "root";
    document.body.appendChild(root);
    ReactDOM.render(<ClientApp />, root);
} else {
    ReactDOM.hydrate(<ClientApp />, exists);
}
